import React, {FC} from 'react';
import {IIconProps} from "../../../types/common";
import {parseStyles} from "../../../utils/parsing";

const HistoryIcon: FC<IIconProps> = ({width, height}) => {
    width = width ? width : 31
    height = height ? height : 31

    return (
        <svg className="svg-icon" height={height} width={width} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h1024v1024H0V0z" fill="#202425" opacity=".01"/>
            <path
                d="M853.333333 512c0 188.5184-152.814933 341.333333-341.333333 341.333333S170.666667 700.5184 170.666667 512 323.4816 170.666667 512 170.666667s341.333333 152.814933 341.333333 341.333333z"
                fill="#FFAA44"/>
            <path
                d="M512 341.333333a34.133333 34.133333 0 0 1 34.133333 34.133334v156.535466l92.398934 92.398934a34.133333 34.133333 0 0 1-48.264534 48.264533l-102.4-102.4A34.133333 34.133333 0 0 1 477.866667 546.133333v-170.666666a34.133333 34.133333 0 0 1 34.133333-34.133334z"
                fill="#FFFFFF"/>
            <path
                d="M626.858667 940.612267c4.881067 18.2272 23.6544 29.149867 41.437866 22.971733a477.866667 477.866667 0 1 0-279.995733 10.001067l37.137067-138.478934a334.506667 334.506667 0 1 1 205.6192-10.513066c-17.646933 6.724267-28.535467 25.258667-23.6544 43.485866l19.456 72.533334z"
                fill="#11AA66"/>
            <path
                d="M443.733333 757.998933a17.066667 17.066667 0 0 0-29.149866-12.049066l-214.766934 214.801066a17.066667 17.066667 0 0 0 12.049067 29.115734H426.666667a17.066667 17.066667 0 0 0 17.066666-17.066667v-214.801067z"
                fill="#11AA66"/>
        </svg>
    );
}
export default HistoryIcon;